import React from 'react';
import PortfolioBoxContainer from './portfolio-box.styles';

const PortfolioBox = ({ imageUrl, name, type }) => {
    return (
        <PortfolioBoxContainer>
            <img src={`${imageUrl}`} alt="" />
            <div className="caption">
                <h4>{name}</h4>
                <p>{type}</p>
            </div>
        </PortfolioBoxContainer>
    );
};
export default PortfolioBox;
